<template>
  <section class="layout">
    <sidebar v-if="appLoaded && !isBeaconAdmin" />

    <div class="content-wrapper">
      <div class="navbar bg-white v-center space-between" style="padding: 0 10px 0 0;">
        <div class="nav-left-spacer"></div>

        <div class="v-center">
          <div class="notification-container">
            <div class="notification">
              <notification-box v-if="!(isBeaconAdmin || tenantType === 2)" :notifications="notification" />
            </div>
          </div>

            <button class="btn s mr-3 ml-5 pointer" v-if="isOnFactoryLevel" @click="exitFactory">
              <div class="v-center">
                <img
                src="~@/assets/images/icons/exit-icon.svg"
                width="14px"
                class="mr-1"
              />
              <span>
                Exit
              </span>
              </div>
            </button>

          <div v-if="!isBeaconAdmin && !isOnFactoryLevel" class="tenant-dropdown">
            <single-select-drop-down
              :options="filteredChildTenants"
              :filterTenant="filterCompany"
              :current="selectedTenantList"
              :tenantDropdown="true"
              @selected="tenantAndProjectChange"
            />
          </div>

          <single-select-drop-down
            label="Projects"
            :options="computedProjectList"
            :current="selectedProjectComputed"
            @selected="projectChange"
            v-if="showProjectDropdown && tenantType !== 2 && !isBeaconAdmin && !isOnFactoryLevel"
          />

          <div class="hamburger relative" v-click-outside="closeOnOutsideClick">
            <img
              @click="openUserOptions = true"
              src="~@/assets/images/hameburger.png"
              alt=""
              class="pointer"
            />
            <div class="user-dropdown" v-if="openUserOptions">
              <div class="user-name text-1 s elipsis-text">
                <span class="brand weight-600">Hi,</span>
                {{ user.first_name }}
                {{ user.last_name }}
              </div>
              <router-link class="user-dropdown--option" to="/profile">Profile</router-link>
              <div class="user-dropdown--option pointer" @click="logout">Logout</div>
            </div>
          </div>
        </div>
      </div>

      <div :class="!isBeaconAdmin ? 'main bg':'main2 bg'">
        <slot />
      </div>
    </div>
  </section>
</template>

<script>
import NotificationBox from './notifications.vue'
import SingleSelectDropDown from './singleSelectDropDown.vue'
import Sidebar from './sidebar.vue'
import { mapGetters } from 'vuex'
import Config from '@/config.js'
import { previousPath } from '@/router'
import { getTokenStorage, logout } from '@/api/session'

export default {
  name: 'LayoutComponent',
  components: { Sidebar, NotificationBox, SingleSelectDropDown },
  data () {
    return {
      module: '',
      notification: [],
      openUserOptions: false,
      selectedTenant: null,
      selectedProject: null
    }
  },
  methods: {
    exitFactory () {
      this.$store.commit('exitFactory')
      this.$router.push('/factories')
    },
    closeOnOutsideClick () {
      this.openUserOptions = false
    },
    projectChange (project) {
      const storage = getTokenStorage()
      storage.removeItem('projectId')
      storage.removeItem('dtxProjectToken')

      if (project.id || project.id === 0) {
        this.selectedProject = project.id
        this.$store.commit('setProjectIdForCollaborator', null)
      }
      if (this.collaborator && this.selectedProject !== 0) {
        this.$store.commit('setProjectIdForCollaborator', project.id)
        if (window.location.pathname.includes('bom')) {
          this.$router.replace({ path: '/bom/project', query: { projectId: project.id } })
        } else if (window.location.pathname.includes('insights')) {
          this.$router.replace({ path: '/insights/project/personal', query: { projectId: project.id } })
        }
      } else if (this.collaborator && this.selectedProject === 0) {
        if (window.location.pathname.includes('bom')) {
          this.$router.push('/bom/product')
        } else if (window.location.pathname.includes('insights')) {
          this.$router.push('/insights/product/personal')
        }
      } else {
        this.rearrangeRouting(project.id)
        storage.setItem(Config.localstorageKeys.LAST_OPENED_PROJECT, this.selectedProject)
      }
    },
    tenantAndProjectChange (projects) {
      const storage = getTokenStorage()
      if (projects.id || projects.id === 0) {
        this.selectedTenant = projects.id
      }
      if (!projects.collaborator) {
        storage.removeItem(Config.localstorageKeys.COLLABORATOR_ID)
        storage.setItem(Config.localstorageKeys.LAST_OPENED_TENANT, projects.id)
      } else {
        storage.setItem(Config.localstorageKeys.COLLABORATOR_ID, projects.id)
      }
      storage.setItem(Config.localstorageKeys.COLLABORATOR, projects.collaborator)
      storage.setItem(Config.localstorageKeys.TENANT_TYPE, projects.tenant_type)
      window.location.href = '/'
    },
    logout,
    rearrangeRouting (id) {
      switch (window.location.pathname.split('/')[1]) {
      case Config.MODULE_ROUTE.FORM: window.location.replace(`/${Config.MODULE_ROUTE.FORM}`); break
      case Config.MODULE_ROUTE.PROJECTS: window.location.replace(`/${Config.MODULE_ROUTE.PROJECTS}`); break
      case Config.MODULE_ROUTE.DOCUMENTS: window.location.replace(`/${Config.MODULE_ROUTE.DOCUMENTS}`); break
      case Config.MODULE_ROUTE.ITEM_MASTER: window.location.replace(`/${Config.MODULE_ROUTE.ITEM_MASTER}/1`); break
      case Config.MODULE_ROUTE.BOM: {
        const endPoint = id === 0 ? '/product' : '/project'
        window.location.replace(`/${Config.MODULE_ROUTE.BOM + endPoint}`)
        break
      }
      case Config.MODULE_ROUTE.PROJECT_PLANNER: window.location.replace(`/${Config.MODULE_ROUTE.PROJECT_PLANNER}`); break
      case Config.MODULE_ROUTE.TIME_SHEET: window.location.replace(`/${Config.MODULE_ROUTE.TIME_SHEET}/update`); break
      case Config.MODULE_ROUTE.FORECAST: window.location.replace(`/${Config.MODULE_ROUTE.FORECAST}/material-forecast`); break
      case Config.MODULE_ROUTE.SETTINGS: window.location.replace(`/${Config.MODULE_ROUTE.SETTINGS}`); break
      case Config.MODULE_ROUTE.INSIGHTS: {
        let path = window.location.href
        path = id ? path.replace('product', 'project') : path.replace('project', 'product')
        window.location.href = `${path}`
        break
      }
      default: window.location.replace('/'); break
      }
    }
  },
  computed: {
    ...mapGetters([
      'user', 'openTenantId', 'openProjectId', 'appLoaded', 'isBeaconAdmin',
      'tenantList', 'parentTenantsList', 'childTenantsList', 'tenantProjectList',
      'isOnProjectLevel', 'collaborator', 'collaboratorId', 'tenantType', 'projectIdForCollaborator', 'isOnFactoryLevel'
    ]),
    filteredChildTenants () {
      return this.childTenantsList.filter((tenant) => ((tenant.status === 1 || tenant.status === 4) && tenant.target_tenant.status === 1))
    },
    showProjectDropdown () {
      return (!this.collaborator || this.module === 'bom' || this.module === 'document-view' || this.module === 'project-planner' || this.module === 'forms' || this.module === 'insights')
    },
    filterCompany () {
      return this.tenantList.filter((tenant) => tenant.status === Config.USER_STATUS_MAP.ACTIVE || tenant.status === Config.USER_STATUS_MAP.INVITED)
    },
    computedProjectList () {
      const projectList = [...this.tenantProjectList.map((project) => ({ id: project.id, name: project.name }))]
      if (!this.collaborator || this.$route.path.includes('/forms') || this.$route.path.includes('/insights') || this.$route.path.includes('/document-view') || this.$route.path.includes('/bom')) {
        projectList.unshift({ id: 0, name: 'Master' })
      }
      return projectList
    },
    selectedProjectComputed () {
      const storage = getTokenStorage()
      const projectId = storage.getItem('projectId')
      const currentProject = this.tenantProjectList.filter((project) => this.selectedProject === project.id || projectId === project.id)
      return currentProject.length > 0 ? currentProject[0] : { name: 'Master', id: 0 }
    },
    selectedTenantList () {
      const TenantList = [
        ...this.filteredChildTenants.map(item => ({ id: item.target_tenant.id, company_name: item.target_tenant.company_name })),
        ...this.parentTenantsList.map(item => ({ id: item.source_tenant.id, company_name: item.source_tenant.company_name }))
      ]
      const currentTenant = this.tenantList.filter((tenant) => this.selectedTenant === tenant.id)
      const currentProject = TenantList.filter((tenant) => this.selectedTenant === tenant.id)
      return currentProject.length > 0 ? currentProject[0] : currentTenant[0]
    }
  },
  watch: {
    computedProjectList () {
      if (this.$route.path.includes('/project-planner') && !previousPath.includes('/project-planner')) {
        this.projectChange(this.computedProjectList[0])
      }
    },
    openProjectId (newVal) {
      if (!this.collaborator) this.selectedProject = newVal
    },
    '$route.path' () {
      this.module = this.$route.path.split('/')[1].toLowerCase()
      if (this.collaborator && this.$route.path.includes('/project-planner')) {
        this.projectChange(this.computedProjectList[0])
      }
      if (this.$route.path.split('/')[1].toLowerCase() !== previousPath.split('/')[1].toLowerCase()) {
        this.$store.commit('removeProjectIdForCollaborator')
        if (this.collaborator) this.selectedProject = 0
      }
    }
  },
  mounted () {
    this.module = this.$route.path.split('/')[1].toLowerCase()
    this.selectedTenant = this.collaborator ? this.collaboratorId : this.openTenantId
    this.selectedProject = !this.collaborator ? this.openProjectId : this.projectIdForCollaborator
  }
}
</script>

<style lang="scss" scoped>
.layout {
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;     /* Forces sidebar and content to stay siblings */
  overflow: hidden;

  /* Target Sidebar specifically to be as wide as it defines itself */
  sidebar {
    flex: 0 0 auto;      /* Prevents shrinking/growing from Layout side */
    z-index: 10;
  }

  .content-wrapper {
    display: flex;
    flex-direction: column;
    flex: 1 1 0;         /* Fill the remaining width */
    min-width: 0;        /* Secret sauce: allows container to be smaller than its child content */
    height: 100vh;
    overflow: hidden;
  }

  .navbar {
    height: 60px;
    width: 100%;
    padding: 10px;
    border-bottom: var(--border);
    flex-shrink: 0;
  }

  .main, .main2 {
    flex-grow: 1;
    overflow: auto;       /* Module horizontal scroll happens ONLY here */
    width: 100%;
    background-color: #ffffff;
  }

  .main { padding: 0 5px 0 3px; }
  .main2 { padding: 0; }

  /* Dropdown & Notification Styles */
  .user-dropdown {
    position: absolute;
    top: 100%;
    right: -5px;
    width: 200px;
    background-color: var(--bg-color);
    z-index: 100;
    border-radius: 12px;
    filter: drop-shadow(0 0 4px rgba(0, 0, 0, 0.2));
    padding: 10px;
    &::before {
      content: "";
      position: absolute;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 14px solid var(--bg-color);
      top: -14px;
      right: 14px;
    }
    &--option {
      display: block;
      color: var(--brand-color-1);
      background-color: var(--bg-color);
      font-size: var(--text-s);
      padding: 4px 12px;
      margin-top: 6px;
      &:hover { box-shadow: 0 0 5px rgba(0, 0, 0, 0.2); }
    }
  }

  .tenant-dropdown { padding: 6px 16px; }
  .notification-container { position: relative; }
}

.hamburger { top: 120%; }
</style>
